import { Switch } from "@sfc/ui";
import { useCurrentUser } from "@client/hooks/use-current-user";
import { setForceStreaming, useForceStreaming } from "./forceStreamingStore";

// Dev-only override that makes every player ignore this device's downloaded
// videos and stream instead (see forceStreamingStore / useVideoSource) — for
// testing the streaming pipeline on a device that has downloads, without
// deleting them. Rendered in the queue drawer's downloads footer on the iPad.
//
// Self-gating on the REAL logged-in user being an SFC admin — not the
// effective user: a dev tool must not vanish while an admin impersonates a
// funder, and must never appear because the impersonated identity is an
// admin. Callers can render it unconditionally.
export function ForceStreamingToggle() {
  const { data: currentUser } = useCurrentUser();
  const forceStreaming = useForceStreaming();

  if (!currentUser?.isSfcAdmin) return null;

  return (
    <section className="flex items-center justify-between gap-3 rounded-xl border border-dashed border-amber-500/60 bg-card p-4">
      <div className="flex flex-col gap-0.5">
        <span className="flex items-center gap-2 text-sm font-medium">
          Force streaming
          <span className="rounded bg-amber-500/15 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-600">
            Dev only
          </span>
        </span>

        <span className="text-xs text-muted-foreground">
          Ignore this device&apos;s downloaded videos and always stream.
          Downloads are kept. Turning it off applies when a video is next
          opened.
        </span>
      </div>

      <Switch
        checked={forceStreaming}
        onCheckedChange={setForceStreaming}
        aria-label="Force streaming (dev only)"
      />
    </section>
  );
}
